'use strict';

// Tealium events of the revamp (OTB26-2260, BitBang doc "TealiumIQ Margiela Revamp" V0.3).
// int_mf_tealium/tealiumEvents is shared with Marni and Jil Sander and stays untouched: where the
// revamp needs another payload its handler is unbound here, possible because main.js runs this
// module after tealiumEvents.

var SEARCH_CATEGORY_KEY = 'mm_tealium_search_category';
var CF_HEADLINES = '.fragment-plp__headline, .fragment-pdp__headline, .fragment-editorial__headline';

// Captured before any event: search_open rewrites utag.data.page_type
var pageType = window.utag_data ? window.utag_data.page_type : '';

function utagReady() {
  return typeof utag !== 'undefined' && utag && utag.data;
}

function clean(text) {
  return (text || '').replace(/\s+/g, ' ').trim();
}

/**
 * Event fields go on utag.data as the doc does, then utag.link (or utag.view).
 * @param {Object} fields - fields of the event
 * @param {string} [method] - 'view' for the events the doc sends as page views
 */
function track(fields, method) {
  if (!utagReady()) return;

  Object.keys(fields).forEach(function (key) {
    utag.data[key] = fields[key];
  });
  if (method === 'view') utag.view(utag.data);
  else utag.link(utag.data);
}

/**
 * Like track, then puts the previous values back: the search fields describe the sheet, later
 * events on the page must keep the page values (page_type product for the PDP rules).
 * @param {Object} fields - fields of the event
 * @param {string} [method] - see track
 */
function trackTransient(fields, method) {
  if (!utagReady()) return;

  var saved = {};
  Object.keys(fields).forEach(function (key) {
    saved[key] = utag.data[key];
  });

  track(fields, method);

  Object.keys(saved).forEach(function (key) {
    if (saved[key] === undefined) delete utag.data[key];
    else utag.data[key] = saved[key];
  });
}

/**
 * Page-level variable. The bundle is deferred and utag.js async, so utag.js may have read
 * utag_data already: write both, the page view gets it when utag.js loads later.
 * @param {string} key - data layer key
 * @param {string} value - value
 */
function setPageVar(key, value) {
  if (window.utag_data) window.utag_data[key] = value;
  if (utagReady()) utag.data[key] = value;
}

function searchFields(eventName) {
  return {
    page_type: 'search',
    page_section: 'search',
    event_name: eventName,
    page_name: utag.data.store_country + (eventName === 'search_close' ? ':search close' : ':search open')
  };
}

function trackSearchCategory(category) {
  // Read on the results page, which loads next
  try {
    sessionStorage.setItem(SEARCH_CATEGORY_KEY, category);
  } catch (e) {
    // storage unavailable: the results page falls back to Search Keyword
  }

  if (!utagReady()) return;

  trackTransient({
    event_name: 'search_category',
    page_name: utag.data.store_country + ':search open',
    search_category: category
  });
}

/**
 * First segment of a menu label: the tier text span, or for the L2 title its own text without
 * the +/- accordion spans.
 * @param {HTMLElement} el - menu item
 * @returns {string} the label
 */
function menuText(el) {
  var text = el.querySelector('.mm-link--tier-text, .mm6-link--tier-text');
  if (text) return clean(text.textContent);

  return clean(Array.prototype.filter.call(el.childNodes, function (node) {
    return node.nodeType === 3;
  }).map(function (node) {
    return node.textContent;
  }).join(' '));
}

function updateContentFragments() {
  var names = [];

  Array.prototype.forEach.call(document.querySelectorAll(CF_HEADLINES), function (el) {
    var name = clean(el.textContent);
    if (name && names.indexOf(name) === -1) names.push(name);
  });

  // Rebuilt from the DOM: filters can also remove fragments
  if (names.length || (window.utag_data && window.utag_data.content_fragment_impression)) {
    // Format agreed with BitBang: "[CONTENT_FRAGMENT], ..."
    setPageVar('content_fragment_impression', names.join(', '));
  }
}

/**
 * Page-level variables, set when the module loads: main.js requires it before document ready,
 * because utag.js (deferred right after main.js) can send the page view before the ready handlers.
 */
function initPageVars() {
  var category = null;
  try {
    category = sessionStorage.getItem(SEARCH_CATEGORY_KEY);
    sessionStorage.removeItem(SEARCH_CATEGORY_KEY);
  } catch (e) {
    // storage unavailable
  }

  // Results page: fields of the doc missing from the server data layer
  if (pageType === 'search') {
    setPageVar('page_section', 'search');
    setPageVar('search_category', category || 'Search Keyword');
  } else if (category && (pageType === 'listing' || pageType === 'product')) {
    // PLP or PDP reached from the search sheet: page_section stays the page one
    setPageVar('search_category', category);
  }

  updateContentFragments();
}

function trackSizeGuideOpen() {
  track({ event_name: 'size_guide_open' });
}

module.exports = {
  // 2.4 - three disjoint entry points, one event each
  sizeGuideOpen: function () {
    // MM: size tab of product-detail-sheet. Not the sheet opening: the same sheet also opens on
    // the materials and details tabs.
    document.addEventListener('MMTabs:tabSwitched', function (e) {
      if (e.detail && e.detail.targetId === 'tab-size-dimensions') trackSizeGuideOpen();
    });

    // MM6: dedicated sheet (its data-tab-target finds no tab, no tabSwitched)
    document.addEventListener('MMSheet:opening', function (e) {
      var sheet = e.detail && e.detail.element;
      if (sheet && sheet.id === 'size-guide-mm6-sheet') trackSizeGuideOpen();
    });

    // MM + MM6: toggle block in the size selector. Capture phase runs before the delegated
    // jQuery handler that removes .d-none, so .d-none still there means it is opening.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.js-show-size-guide-btn');
      var wrapper = btn && btn.closest('.size-guide-toggle-content-wrapper');
      var content = wrapper && wrapper.querySelector('.size-guide-toggle-content');

      if (content && content.classList.contains('d-none')) trackSizeGuideOpen();
    }, true);
  },

  // 2.5 - search_open / search_close
  searchOpenClose: function () {
    // Replaces tealiumEvents.searchOpen in this bundle only: same utag.view, fields of the doc
    $('body').off('search:open').on('search:open', function () {
      if (utagReady()) trackTransient(searchFields('search_open'), 'view');
    });

    $('body').on('search:close', function () {
      if (utagReady()) trackTransient(searchFields('search_close'), 'view');
    });
  },

  // 2.5 - search_category: suggested term, suggested product, or typed keyword
  searchCategory: function () {
    var lastTrackedAt = 0;

    // Capture: the links navigate right away and tiles may stop propagation.
    // Untrusted clicks count too: search.js turns Enter and the search CTA into a click on the selected
    // suggestion or on "show all". Adobe AppMeasurement re-dispatches the same click after its beacon,
    // hence one event per second.
    document.addEventListener('click', function (e) {
      var target = e.target;
      var category;
      if (!target.closest) return;

      // Empty sheet: editorial suggestions. While typing: suggested categories
      if (target.closest('.search-suggestion-list-item a[href], .suggestions-categories-list a[href]')) {
        category = 'Suggested Search Keyword';
      } else if (target.closest('.suggestions-products-grid a[href], .recommendations-search-mm a[href], .recommendations-search-mm6 a[href]')) {
        category = 'Suggested Search Product';
      } else if (target.closest('.js-suggestions-view-all a[href], .js-grid-view-all-container a[href]')) {
        category = 'Search Keyword';
      }

      if (!category || Date.now() - lastTrackedAt < 1000) return;
      lastTrackedAt = Date.now();
      trackSearchCategory(category);
    }, true);

    // Runs after the handler in search.js: if that one prevented the submit it clicked a
    // suggestion or "show all" instead, already tracked by the click listener above.
    $(document).on('submit', 'form[name="simpleSearch"]', function (e) {
      if (!e.isDefaultPrevented()) trackSearchCategory('Search Keyword');
    });

  },

  // 2.6 - headlines of the content fragments on the page, also those loaded later on PLP
  contentFragments: function () {
    // First value set by initPageVars; show more and filter refresh both end with this event
    $('body').on('product:update-plp-cards', updateContentFragments);
  },

  // 2.7 - L1 and L3 only: L2 is a static label from 768px up
  menuClick: function () {
    // Untrusted clicks skipped: Adobe AppMeasurement re-dispatches link clicks after its beacon
    document.addEventListener('click', function (e) {
      var menu = e.isTrusted && e.target.closest && e.target.closest('.header-menu-container');
      if (!menu) return;

      var l1 = e.target.closest('.js-menu-l1-link, .menu-l1-item > a[href]');
      var l3 = !l1 && e.target.closest('.js-menu-l3-list a[href]');
      if (!l1 && !l3) return;

      var parts = [];

      if (l3) {
        var tab = l3.closest('.js-tab-content') || menu;
        var detail = l3.closest('.js-menu-l1-detail');
        var l1Link = detail && tab.querySelector('.js-menu-l1-link[data-l1-id="' + detail.getAttribute('data-l1-id') + '"]');
        var group = l3.closest('.menu-l2-group');
        var l2 = group && group.querySelector('.js-menu-column-title');

        if (l1Link) parts.push(menuText(l1Link));
        if (l2) parts.push(menuText(l2));
      }

      parts.push(menuText(l1 || l3));

      track({
        menu_label: parts.filter(Boolean).join(':'),
        event_name: 'menu_click'
      });
    }, true);
  },

  // 2.8 - wishlist_add / wishlist_remove on every page, product fields from the server response
  wishlist: function () {
    // pdp_wishlist_add is renamed wishlist_add (doc 2.8): drop the shared handler in this bundle
    $('body').off('product:afterAddToWishlist');

    $('body').on('wishlist:tracking', function (e, payload) {
      var utagData = payload && payload.data && payload.data.utagData;
      if (!utagData || !utagReady()) return;

      // event_name on utag.data like the other events; product_* only on the copy: the shared PDP
      // events rebuild them from utag.data, the saved item must not replace the page product
      utag.data.event_name = payload.action === 'remove' ? 'wishlist_remove' : 'wishlist_add';
      utag.link($.extend({}, utag.data, utagData, { page_type: pageType }));
    });
  }
};

initPageVars();
